import { render, staticRenderFns } from "./SelecionarTipoDocumento.vue?vue&type=template&id=321cf0c3"
import script from "./SelecionarTipoDocumento.vue?vue&type=script&lang=js"
export * from "./SelecionarTipoDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports